



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

@Component({
  name: "multipleChoice",
})
export default class MultipleChoice extends Vue {
  private answer: Array<string> = [];
  private zItem!: any;
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: String, default: "QUESTIONNAIRE" }) questionnaireType!: string;

  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }

  // get questionnaireType() {
  //   return QuestionnaireEditModule.questionnaireType;
  // }
  get getColorForAnswer() {
    if (this.zItem.answered) {
      if (this.zItem.rightAnswer) {
        return "type_green";
      } else if (this.zItem.rightAnswer === null) {
        return "type_yellow";
      } else {
        return "red";
      }
    } else {
      return "c999";
    }
  }
}
